import { Injectable } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { ControlPropertyHandler } from './control-property-handler';
import { AbstractPropertyEditor } from '../types';

@Injectable({
  providedIn: 'root'
})
export class DefaultPropertyService implements ControlPropertyHandler<any> {
  propertyName: string = '';

  constructor(private commonConfig: DynamicFormCommonConfig) {}

  handleData(data: any, editor: AbstractPropertyEditor): Observable<any> {
    const sub = new Subject<string>();
    if (data && editor.settings && editor.settings.reg) {
      const reg = editor.settings.reg;
      if (!reg.test(data)) {
        this.commonConfig.log.error(editor.settings.regErrorMsg || 'è¾å¥æ°æ®æ ¼å¼ä¸ç¬¦åè¦æ±');
        sub.error('');
        sub.complete();
        return sub;
      }
    }
    return of(data);
  }
}
